export default __webpack_public_path__ + "static/media/HeroVideo.9d987673.mp4";